module.exports = __webpack_public_path__ + "static/media/image6.1dc13d05.jpg";